'use client';

import { UserNotFoundScreen } from '@prismo-io/feature-user/screens/user-not-found';
import { Application, useRouter } from '@prismo-io/router';
import type { FC } from 'react';

const NotFound: FC = () => {
  const router = useRouter();

  const reset = () => {
    router.push({
      app: Application.APP,
      path: '/',
    });
  };

  return <UserNotFoundScreen reset={reset} />;
};

export default NotFound;
